import { Spinner, cn } from "@hulahoop/ui";
import type { ReactNode } from "react";

export function PanelPlaceholder({
  className,
  loading,
  loadingLabel,
  message,
  action,
}: {
  className: string;
  loading?: boolean;
  loadingLabel: string;
  message?: string;
  action?: ReactNode;
}) {
  if (loading) {
    return (
      <div className={cn(className, "items-center justify-center")}>
        <Spinner label={loadingLabel} />
      </div>
    );
  }
  return (
    <div className={cn(className, "items-center justify-center gap-2")}>
      <p className="text-sm text-muted-foreground">{message}</p>
      {action}
    </div>
  );
}
